import { useEffect } from "react";
import { useDispatch } from "react-redux";
import { setLayoutDashboardTitle } from "../../../store/ui-slice";
import ReportCustomerPointMain from "../../../features/report/report-customer-point/component/ReportCustomerPointMain";

const title = "Report Customer Point";

const ReportCustomerPointPage = () => {
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(setLayoutDashboardTitle({ title }));
  }, []);

  return <ReportCustomerPointMain />;
};

export default ReportCustomerPointPage;
